import TableRows from "./sections/TableRows.jsx";


import TableToolbar from "./sections/TableToolbar.jsx";

/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */




import { Alert, Box, LinearProgress, Pagination, Paper, Skeleton, TableContainer, useMediaQuery } from "@mui/material";
import { useCallback, useEffect, useLayoutEffect, useRef, useState, useTransition } from "react";









const CustomeLayout = ({
  title,
  children,
  headers,
  search,
  rows,
  actions = false,
  length,
  name,
  maxHeight,
  setSort,
  currentRow,
  loading,
  refreshing = false,
  hasMore,
  CurrentPage,
  setPage,
  setSearch,
  setApplySearch,
  total_pages,
  page,
  setSelected,
  selected,
  setRefresh,
  setAllRows,
  editApi,
  setting,
  limit,
  setLimit,
  canSelect = true,
  alart,
  editInputApi,
  defualtSort,
  paginationMode,
}) => {
  //sorting

  const [isAsc, setIsAsc] = useState({});
  const [pageType, setpageType] = useState(2);
  const [rowLenght, setRowLenght] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const observer = useRef();
  const [isPending, startTransition] = useTransition();
  const [open, setOpen] = useState({});

  const lastElement = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore && pageType === 1) {
          setPage((page) => page + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore, CurrentPage]
  );

  const handleClick = (name) => {
    var newSelected = [...selected];

    startTransition(() => {
      if (isSelected(name)) {
        newSelected = newSelected.filter((item) => item.id !== name.id);
      } else {
        newSelected.push(name);
      }
      setSelected(newSelected);
    });
  };

  const selectAll = (e) => {
    e.target.checked ? setSelected(rows) : setSelected([]);
  };
  useEffect(() => {
    if (defualtSort && !loaded) {
      setIsAsc(defualtSort);
      setLoaded(true);
    }
  }, [defualtSort]);
  const isSelected = (row) => {
    var finded = selected?.find((item) => item.id === row.id) ? true : false;
    return finded;
  };
  useEffect(() => {
    if (headers?.length > 0) {
      var l = [{ display: true }];

      headers.map((item) => {
        if (item.showInList && !item.showInExtra) {
          Array.from(Array(item.colSpan).keys()).map((item, i) => {
            l.push({ display: true });
          });
          /*  l.push({ display: true }); */
        } else {
          l.push({ display: false });
        }
      });
      if (actions) {
        actions.map((item) => {
          l.push({ display: true });
        });
      }
      setRowLenght(l);
    }
  }, [headers]);
  const isMd = useMediaQuery("(min-width:900px)");
  useLayoutEffect(() => {
    if (paginationMode === 1 || paginationMode === 2) {
      setpageType(paginationMode);
      return;
    }
    if (localStorage.getItem("pageType")) {
      setpageType(Number(localStorage.getItem("pageType")));
    }
  }, [paginationMode, localStorage.getItem("pageType")]);
  return (
    <Paper
      aria-busy={Boolean(loading || refreshing)}
      sx={{ position: "relative", border: "1px solid #dbdfea", mb: 1, padding: "15px 16px" }}
      elevation={0}
    >
      {(refreshing || (loading && headers?.length > 0)) && <LinearProgress aria-label="در حال تازه‌سازی اطلاعات" sx={{ position: "absolute", top: 0, right: 0, left: 0 }} />}
      {loading && rowLenght.length === 0 ? (
        <div>
          <Skeleton width={"100%"} height={100} />
          <Skeleton width={"100%"} sx={{ mt: "-122px" }} height={600} />
        </div>
      ) : (
        <>
          {" "}
          <TableToolbar title={title} length={length} setSearch={setSearch} search={search} setApplySearch={setApplySearch} setRefresh={setRefresh} setSelected={setSelected} pageType={pageType} limit={limit} setLimit={setLimit} selected={selected} busy={loading || refreshing} />
          <Box
            sx={{
              transform: { md: pageType === 1 ? "rotateX(180deg)" : "" },
              overflowX: "auto",
              mt: "10px",
            }}
          >
            <TableContainer
              sx={{
                /*      overflowX: "auto", */

                maxHeight: pageType === 1 ? maxHeight : "unset",
                minHeight: "70vh",
                transform: pageType === 1 ? "rotateX(180deg)" : "",
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
                /*   overflowY: "overlay", */
              }}
            >
              <TableRows pageType={pageType} setting={setting} canSelect={canSelect} selected={selected} rows={rows} selectAll={selectAll} headers={headers} isAsc={isAsc} setSort={setSort} setIsAsc={setIsAsc} actions={actions} lastElement={lastElement} isSelected={isSelected} handleClick={handleClick} setAllRows={setAllRows} editApi={editApi} editInputApi={editInputApi} currentRow={currentRow} setOpen={setOpen} open={open} loading={loading} rowLenght={rowLenght} />
              {pageType === 2 && total_pages > 1 && (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {isMd ? (
                    <Pagination
                      count={total_pages}
                      variant="outlined"
                      color="primary"
                      page={page}
                      /*     siblingCount={1}
                    boundaryCount={0} */
                      onChange={(_e, value) => {
                        setPage(value);
                      }}
                      sx={{ my: 2 }}
                    />
                  ) : (
                    <Pagination
                      count={total_pages}
                      variant="outlined"
                      color="primary"
                      page={page}
                      siblingCount={1}
                      boundaryCount={0}
                      onChange={(_e, value) => {
                        setPage(value);
                      }}
                      sx={{ my: 2 }}
                    />
                  )}
                </Box>
              )}
            </TableContainer>
          </Box>
        </>
      )}
      {alart && (
        <Alert variant="outlined" severity="info">
          {alart}
        </Alert>
      )}
    </Paper>
  );
};

export default CustomeLayout;
